import type { IconData } from '@stacksjs/iconify-core'

export const alignLeft: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M21 7H3a1 1 0 0 1 0-2h18a1 1 0 0 1 0 2m-4 4H3a1 1 0 0 1 0-2h14a1 1 0 0 1 0 2m4 4H3a1 1 0 0 1 0-2h18a1 1 0 0 1 0 2m-4 4H3a1 1 0 0 1 0-2h14a1 1 0 0 1 0 2\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default alignLeft
